import { RECEIVE_PARTNER, REQUEST_PARTNER } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_PARTNER:
            return { ...state, shouldFetch: false }

        case RECEIVE_PARTNER:
            return { ...state, ...data }

        default:
            return state
    }
}
